import { GroupType } from '@ardoq/api-types';
import { WORKSPACE_ICON_REPRESENTATION } from '../visuals/WORKSPACE_ICON_REPRESENTATION';
import { GraphGroup } from '../graphItems/GraphGroup';
import { RelationshipsNode } from './types';
import { componentInterface } from '@ardoq/component-interface';
import { SvgComponentRepresentation } from '../SvgComponentRepresentation';
import { Rect } from '../Rect';
import { BrokenImageMouseEvents } from '@ardoq/icons';

const clipPath = (radius: number) => `url(#radius-${radius}-clip-path)`;

type RelationshipsViewNodeIconProperties = BrokenImageMouseEvents & {
  graphNode: RelationshipsNode;
  nodeRadius: number;
};
const RelationshipsViewNodeIcon = ({
  graphNode,
  nodeRadius,
  onBrokenImageMouseEnter,
  onBrokenImageMouseLeave,
}: RelationshipsViewNodeIconProperties) => {
  const representationData =
    graphNode instanceof GraphGroup && graphNode.type === GroupType.WORKSPACE
      ? WORKSPACE_ICON_REPRESENTATION
      : graphNode instanceof GraphGroup &&
          graphNode.type === GroupType.COMPONENT
        ? {
            isImage: false,
            value: null,
          }
        : (componentInterface.getRepresentationData(graphNode.modelId) ?? {
            isImage: false,
            value: null,
          });
  const radius = representationData.isImage ? nodeRadius : 8;
  return (
    <SvgComponentRepresentation
      bounds={new Rect(-radius, -radius, radius * 2, radius * 2)}
      representationData={representationData}
      clipPath={clipPath(radius)}
      customArdoqImageProps={{
        onBrokenImageMouseEnter,
        onBrokenImageMouseLeave,
      }}
    />
  );
};

export { RelationshipsViewNodeIcon };
